import {
  Box,
  Grid,
  GridItem,
  Text,
  Flex,
  Icon,
  Heading,
  Link,
  Avatar,
} from '@chakra-ui/react';
import React from 'react';
import { AiOutlineClockCircle } from 'react-icons/ai';
import moment from 'moment';
import VideoPlayer from '../../../components/VideoPlayer';
import DaftarTugas from '../../../components/Pengetahuan/DaftarTugas';
import Diskusi from '../../../components/Pengetahuan/Diskusi';
import { PengetahuanItem } from '../../../../types/pengetahuan';

type Props = {
  pengetahuanItem: PengetahuanItem | null;
  handlePlayerReady: (player: any) => void;
  youtubeId: string;
};

const PengetahuanMateri = ({
  pengetahuanItem,
  handlePlayerReady,
  youtubeId,
}: Props) => {
  const isStaging = process.env.REACT_APP_ENVIRONMENT!.toLowerCase() === 'staging';


  const isYoutubeStream =
    pengetahuanItem?.pengetahuan_materi_saya?.link_streaming?.includes(
      'youtube'
    );

  const videoJsOptions = {
    controls: true,
    responsive: true,
    fluid: true,
    aspectRatio: '16:9',
    controlBar: {
      children: [
        'playToggle',
        'currentTimeDisplay',
        'durationDisplay',
        'volumePanel',
        'fullscreenToggle',
        'controlBar',
      ],
      skipButtons: {
        backward: 10,
        forward: isStaging && 30,
      },
    },
    userActions: {
      hotkeys: false,
      click: false,
    },
    techOrder: ['youtube'],
    sources: [
      {
        src: `https://www.youtube.com/watch?v=${pengetahuanItem?.pengetahuan_materi_saya?.path_file}`,
        type: 'video/youtube',
      },
    ],
    youtube: {
      controls: 0,
      rel: 0,
      modestbranding: 1,
      disablekb: 1,
      fs: 0,
      enablejsapi: 1,
      hl: '',
    },
  };

  return (
    <Grid templateColumns="repeat(8, 1fr)" gap={{ base: 3, md: 5 }}>
      <GridItem colSpan={{ base: 8, md: 5 }}>
        <Box py={4} bgColor="white" rounded="xl">
          <Box px={3}>
            <Heading as="h2" fontSize="xl" fontWeight="semibold" mb={2}>
              {pengetahuanItem?.pengetahuan_materi_saya?.judul}
            </Heading>
          </Box>

          {pengetahuanItem?.jenis_pengetahuan === 'asynchronized' ? (
            <>
              {pengetahuanItem?.pengetahuan_materi_saya?.category === 'pdf' && (
                <Grid w="full" templateColumns="repeat(3, 1fr)" gap={4} px={4}>
                  <GridItem
                    colSpan={{ base: 3, md: 3 }}
                    height={{ base: '300px', md: '450px' }}
                  >
                    <iframe
                      title={`${pengetahuanItem?.pengetahuan_materi_saya.judul}`}
                      src={
                        pengetahuanItem?.pengetahuan_materi_saya.path_file ?? ''
                      }
                      style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                      }}
                    />
                  </GridItem>
                </Grid>
              )}

              {pengetahuanItem?.pengetahuan_materi_saya?.category ===
                'video' && (
                <Grid w="full" templateColumns="repeat(3, 1fr)" gap={4} px={4}>
                  <GridItem colSpan={{ base: 3, md: 3 }}>
                    <VideoPlayer
                      options={videoJsOptions}
                      onReady={handlePlayerReady}
                      nonActiveProgressBar={!isStaging}
                    />
                  </GridItem>
                </Grid>
              )}
            </>
          ) : (
            <>
              {isYoutubeStream ? (
                <Grid w="full" templateColumns="repeat(3, 1fr)" gap={4} px={4}>
                  <GridItem
                    colSpan={{ base: 3, md: 3 }}
                    h={{ base: '300px', md: '450px' }}
                  >
                    <iframe
                      title="youtube video"
                      src={`https://www.youtube.com/embed/${youtubeId}`}
                      allowFullScreen
                      style={{ width: '100%', height: '100%' }}
                    />
                  </GridItem>
                </Grid>
              ) : (
                <Grid w="full" templateColumns="repeat(3, 1fr)" gap={4} px={4}>
                  <GridItem colSpan={{ base: 3, md: 3 }} h={'330px'}>
                    <Box
                      bg="#F6F5F8"
                      h="full"
                      rounded="md"
                      py={4}
                      display="flex"
                      flexDir="column"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Text color="gray.900" fontSize="lg">
                        Pembelajaran online Anda telah dimulai.
                      </Text>
                      <Text color="gray.500" fontSize="md" mt={3}>
                        Segera masuk ke sesi anda
                      </Text>
                      <Link
                        href={
                          pengetahuanItem?.pengetahuan_materi_saya
                            ?.link_streaming ?? '#'
                        }
                        isExternal
                        bg="blue.500"
                        color="white"
                        px={4}
                        py={2}
                        rounded="md"
                        mt={2}
                        _hover={{ bg: 'blue.600' }}
                        textAlign="center"
                        display="inline-block"
                      >
                        Ikuti Sesi
                      </Link>
                    </Box>
                  </GridItem>
                </Grid>
              )}
            </>
          )}

          {/* Pemateri Section */}
          <Box px={3} py={4} borderTop="1px" borderColor="gray.200">
            <Flex align="center" mb={4}>
              <Avatar
                size="lg"
                name={pengetahuanItem?.pengetahuan_materi_saya?.nama_pemateri}
                bg="green.500"
                color="white"
                mr={3}
                fontWeight="bold"
              />

              <Box>
                <Text fontSize="md" fontWeight="semibold" mb={1}>
                  <Text as="span" color="gray.900" fontSize="inherit">
                    {pengetahuanItem?.pengetahuan_materi_saya?.nama_pemateri}
                  </Text>
                  <Text
                    as="span"
                    color="gray.700"
                    fontWeight="normal"
                    fontSize="inherit"
                  >
                    {' | Pemateri'}
                  </Text>
                </Text>
                {pengetahuanItem?.created_at && (
                  <Flex alignItems="center" mt={2}>
                    <Icon as={AiOutlineClockCircle} boxSize={4} mr={2} />
                    <Text fontSize="sm">
                      {moment(
                        pengetahuanItem?.created_at,
                        'YYYY-MM-DD HH:mm:ss'
                      ).fromNow()}
                    </Text>
                  </Flex>
                )}
              </Box>
            </Flex>
            <Text fontSize="md" fontWeight="semibold" color="gray.800" mb={4}>
              Deskripsi
            </Text>
            <Box
              fontSize="sm"
              color="gray.700"
              lineHeight="1.6"
              as="div"
              dangerouslySetInnerHTML={{
                __html:
                  pengetahuanItem?.description ||
                  'Pemateri berpengalaman dalam bidang ini.',
              }}
            />
          </Box>
        </Box>
      </GridItem>
      <GridItem colSpan={{ base: 8, md: 3 }}>
        <DaftarTugas />
        {pengetahuanItem?.jenis_pengetahuan === 'synchronized' && (
          <Diskusi 
            readOnly={pengetahuanItem?.status_pengetahuan === 'selesai'} 
            pengetahuanId={pengetahuanItem?.id || 0}
          />
        )}
      </GridItem>
    </Grid>
  );
};

export default PengetahuanMateri;
